import { CHART_HEX_INTERACTIVE, CHART_HEX_SUPPORT_SUCCESS } from '@sphere/shared/util'
import { BarChartWrapper } from '../shared'
import { Tile } from '@carbon/react'
import styles from './EstablishmentAnalytics.module.scss'

export interface GradeMetrics {
  grade: string
  student_count: number
  unique_activities: number
  total_attempts: number
  avg_score: number
  passed_attempts: number
  success_rate: number
}

export interface EstablishmentGradesChartProps {
  grades: GradeMetrics[]
}

export function EstablishmentGradesChart({
  grades,
}: EstablishmentGradesChartProps) {
  if (!grades || grades.length === 0) {
    return (
      <Tile className={styles.emptyState}>
        <p>Aucune donnée disponible pour les niveaux.</p>
      </Tile>
    )
  }

  const chartData = grades.map(grade => ({
    grade: grade.grade,
    élèves: grade.student_count,
    scoreMoyen: grade.avg_score,
  }))

  return (
    <>
      <BarChartWrapper
        data={chartData}
        bars={[
          {
            dataKey: 'élèves',
            name: 'Élèves',
            fill: CHART_HEX_INTERACTIVE,
          },
          {
            dataKey: 'scoreMoyen',
            name: 'Score moyen',
            fill: CHART_HEX_SUPPORT_SUCCESS,
          },
        ]}
        xAxisKey="grade"
        title="Performance par niveau"
        height={400}
      />
    </>
  )
}
